module.exports = __webpack_public_path__ + "img/Cross_Symbol_big.9624aa6c.svg";